import { render, staticRenderFns } from "./UnidadMedida.view.vue?vue&type=template&id=74f2daa1&"
import script from "./UnidadMedida.view.vue?vue&type=script&lang=js&"
export * from "./UnidadMedida.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports